// App.js

import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'

import SideBar from './SideBar';
import Content from './Content';
import Login from './Login.js'
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import NavBar from './NavBar';

class Main extends Component {

  constructor(props) {
    super(props);

    this.state = { updateStation : false };
  }

  updateStation() {
    this.setState({ updateStation : true});
  }

  render() {
    return (
      <div className="wrapper">
        <NavBar {...this.props} user={this.props.user} station={this.props.station} />
        <SideBar updateStation={this.state.updateStation} handleLogout={this.props.handleLogout} user={this.props.user}/>
        <Content {...this.props} user={this.props.user} updateUserProfile={this.props.updateUserProfile} handleUpdateStation={this.props.handleUpdateStation}/>
      </div>
    )
  }
}

class App extends Component {

  constructor(props) {
    super(props);

    let payloadString = localStorage.getItem('payload');
    this.mainRef = React.createRef();

    let user = {
      isLoggedIn: false,
      payload: {}
    }
    let shouldFetchStations = false;
    if (payloadString) {
      user.isLoggedIn = true;
      user.payload = JSON.parse(payloadString);
      if (!user.payload.user.member) {
        this.props.history.push('/login');
      }
    }

    this.state = {
      user: user,
      station : {},
      shouldFetchStations : shouldFetchStations
    };

    this.changePayload = this.changePayload.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.updateUserProfile = this.updateUserProfile.bind(this);
    this.handleUpdateStation = this.handleUpdateStation.bind(this);
  }

  changePayload(payload) {
    localStorage.setItem('payload', JSON.stringify(payload));
    let user = this.state.user;
    user.payload = payload;
    user.isLoggedIn = true;
    this.setState({ user: user, shouldFetchStations : false });
  }

  updateUserProfile(newUser) {
    let user = this.state.user;
    user.payload.user = newUser;
    localStorage.setItem('payload', JSON.stringify(user.payload));
    this.setState({user : user, station: {} });
  }

  handleLogout() {
    localStorage.removeItem('payload');
    let user = this.state.user;
    user.payload = {};
    user.isLoggedIn = false;
    this.setState({ user: user, station: {} });
  }

  handleUpdateStation(station) {
    this.setState({station : station});
    this.mainRef.current.updateStation();
  }

  render() {
    return (
      <Switch>
        <Route path="/reset" render={(props) => <ResetPassword {...props}/>}/>
        <Route path="/login"  render={(props) => <Login {...props} changePayload={this.changePayload} />} />
        <Route path="/forgot-password">
          <ForgotPassword/>
        </Route>
        <Route path="/" render={() => (
          this.state.user.isLoggedIn ?
            (<Main {...this.props} ref={this.mainRef} handleLogout={this.handleLogout} user={this.state.user} station={this.state.station} updateUserProfile={this.updateUserProfile} handleUpdateStation={this.handleUpdateStation}/>) :
            (<Redirect to="/login" />)
        )} />
      </Switch>
    );
  }
}

export default withRouter(App);